import { Dispatch } from 'react'
import { AppState } from '../../../../global/store'
import { ApiResponse, RequestState } from '../../../types'
import * as api from '../services/api'
import { Contact, ContactForm } from './store'
import ReactGA from 'react-ga'

import {
  REMOVE_CONTACT_RECEIVED,
  REMOVE_CONTACT_REQUEST,
  REMOVE_CONTACT_ERROR,
  LOAD_CONTACTS_ERROR,
  LOAD_CONTACTS_RECEIVED,
  LOAD_CONTACTS_REQUEST,
  UPDATE_ADD_FORM_FIELD,
  UPDATE_CONTACT_RECEIVED,
  UPDATE_CONTACT_REQUEST,
  UPDATE_CONTACT_ERROR,
  UPDATE_ADD_FORM
} from './reducers'

export type ContactsSettingsAction =
  | { type: typeof LOAD_CONTACTS_REQUEST }
  | { type: typeof LOAD_CONTACTS_RECEIVED, contacts: Contact[] }
  | { type: typeof LOAD_CONTACTS_ERROR }
  | { type: typeof REMOVE_CONTACT_REQUEST, contactId: string }
  | { type: typeof REMOVE_CONTACT_RECEIVED, contactId: string }
  | { type: typeof REMOVE_CONTACT_ERROR, contactId: string }
  | { type: typeof UPDATE_ADD_FORM_FIELD, field: string, value: string }
  | { type: typeof UPDATE_ADD_FORM, contactForm: ContactForm }
  | { type: typeof UPDATE_CONTACT_RECEIVED }
  | { type: typeof UPDATE_CONTACT_REQUEST }
  | { type: typeof UPDATE_CONTACT_ERROR }

export function loadContacts(accountId: string) {
  return async function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    try {
      dispatch({
        type: LOAD_CONTACTS_REQUEST
      })

      const response = await api.getContacts(accountId)
      const mappedContacts = response.data.map((data: ApiResponse) => mapContact(data))

      dispatch({
        type: LOAD_CONTACTS_RECEIVED,
        contacts: mappedContacts
      })
    } catch {
      dispatch({
        type: LOAD_CONTACTS_ERROR
      })
    }
  }
}

export function addContact(accountId: string, contactForm: ContactForm) {
  return async function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    try {
      dispatch({
        type: UPDATE_CONTACT_REQUEST
      })

      await api.postContact(accountId, contactForm)
      ReactGA.event({ category: 'account-settings', action: 'Contact Added' })

      dispatch({
        type: UPDATE_CONTACT_RECEIVED
      })
    } catch {
      dispatch({
        type: UPDATE_CONTACT_ERROR
      })
    }
  }
}

export function updateContact(accountId: string, contactId: string, contactFields: ContactForm) {
  return async function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    try {
      dispatch({
        type: UPDATE_CONTACT_REQUEST
      })

      await api.updateContact(accountId, contactId, contactFields)
      ReactGA.event({ category: 'account-settings', action: 'Contact Updated' })

      dispatch({
        type: UPDATE_CONTACT_RECEIVED
      })
    } catch {
      dispatch({
        type: UPDATE_CONTACT_ERROR
      })
    }
  }
}

export function updateAddForm(contactForm: ContactForm) {
  return function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    dispatch({
      type: UPDATE_ADD_FORM,
      contactForm
    })
  }
}


export function updateAddFormField(field: string, value: string) {
  return async function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    dispatch({
      type: UPDATE_ADD_FORM_FIELD,
      field,
      value
    })
  }
}

export function removeContact(accountId: string, contactId: string) {
  return async function (state: AppState, dispatch: Dispatch<ContactsSettingsAction>) {
    try {
      dispatch({
        type: REMOVE_CONTACT_REQUEST,
        contactId
      })

      await api.deleteContact(accountId, contactId)
      ReactGA.event({ category: 'account-settings', action: 'Contact Removed' })

      dispatch({
        type: REMOVE_CONTACT_RECEIVED,
        contactId
      })
    } catch (error) {
      dispatch({
        type: REMOVE_CONTACT_ERROR,
        contactId
      })

      throw error
    }
  }
}

function mapContact(data: ApiResponse) {
  return {
    id: data.id,
    name: data.name ? data.name : '',
    email: data.email ? data.email : '',
    phone: data.phone ? data.phone : '',
    mobile: data.mobile ? data.mobile : '',
    deleteRequestState: RequestState.NotLoaded
  }
}
